import React from 'react';
import { PageNotFound } from '../../common/PageNotFound';
import { useSession } from '../../common/hooks';
import { SignOutPage } from '../pages/SignOutPage';

type SignOutControllerProps = {
  page?: 'main';
};

export const SignOutController: React.FC<SignOutControllerProps> = ({ page = 'main' }) => {
  const { clearSession } = useSession();

  React.useEffect(() => {
    clearSession();
  }, []);
  switch (page) {
    case 'main':
      return <SignOutPage />;
    default:
      return <PageNotFound />;
  }
};
